"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var confirmation_sheet_component_1 = require("./../../../../Messages/confirm-sheet/confirmation-sheet.component");
var conversationService_1 = require("./../../../../Services/conversationService");
var service_service_1 = require("src/app/Services/service.service");
var core_2 = require("@angular/core");
var router_1 = require("@angular/router");
var environment_1 = require("src/environments/environment");
var GroupListComponent = /** @class */ (function () {
    function GroupListComponent(mainService, conversationService, router, route) {
        var _this = this;
        this.mainService = mainService;
        this.conversationService = conversationService;
        this.router = router;
        this.route = route;
        this.perPage = 24; //count convs per page 0 is for all
        this.page = 0;
        this.conversations = [];
        this.images = {};
        this.loading = false;
        this.noConversationsInfo = false;
        this.paginator = new core_1.QueryList();
        this.refreshingLastList = false;
        this.activeGroupChanged = new core_2.EventEmitter();
        this.currentUserIsAdmin = false;
        this._allConversationsCount = 0;
        this._selectedConvCount = 0;
        this.convListArray = [];
        this.checboxListArray = [];
        this.selectAllCheckbox = false;
        this.route.queryParams.subscribe(function (params) {
            var paramPage = params['page'] - 1;
            if (paramPage)
                _this.page = paramPage;
        });
    }
    GroupListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userNick = this.mainService.userService.getUserId();
        this.currentUserIsAdmin = this.mainService.userService.isAdmin();
        var lastConversations = this.conversationService.getLastConversations();
        //new
        if (lastConversations) {
            this.refreshingLastList = true;
            this.conversations = lastConversations;
            this.reloadConversations(false);
        }
        else {
            this.reloadConversations();
        }
        this.conversationService.getConversationsCount().then(function (result) {
            _this._allConversationsCount = result;
        });
    };
    GroupListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.convListArray = this.convList.toArray();
        this.convList.changes.subscribe(function (t) {
            _this.ngForRendred();
        });
        this.checboxList.changes.subscribe(function (t) {
            _this.ngForRendredChecboxes();
        });
    };
    GroupListComponent.prototype.ngForRendred = function () {
        this.convListArray = this.convList.toArray();
    };
    GroupListComponent.prototype.ngForRendredChecboxes = function () {
        this.checboxListArray = this.checboxList.toArray();
    };
    GroupListComponent.prototype.showDemoAdInfo = function (conversation) {
        return conversation.demoAdvertisement && this.currentUserIsAdmin;
    };
    GroupListComponent.prototype.activateGroup = function (conversation) {
        this.activeGroup = conversation;
        this.activeGroupChanged.emit(this.activeGroup);
    };
    GroupListComponent.prototype.navigateToAdv = function (e, advId) {
        e.stopPropagation();
        this.mainService.route.navigate(["adv-detail/" + advId]);
    };
    GroupListComponent.prototype.resolveConversationSenderNick = function (conversation) {
        if (conversation.senderId == this.userNick) {
            return "You";
        }
        else
            return conversation.senderNick;
    };
    GroupListComponent.prototype.deleteConversation = function (e, conversationId, arrayIndex) {
        var _this = this;
        e.stopPropagation();
        this.mainService.showConfirm("Are you sure?", "300px").then(function (res) {
            if (res == confirmation_sheet_component_1.ConfirmationResult.Yes) {
                var thisConvElement_1 = document.getElementsByClassName('conversation-' + conversationId)[0];
                thisConvElement_1.classList.add("deleting");
                _this.conversationService.deleteConversation(conversationId, arrayIndex).then(function (res) {
                    thisConvElement_1.remove();
                    _this.mainService.showInformation("Conversation deleted");
                }).catch(function (err) {
                    _this.mainService.showError(err);
                });
            }
        });
    };
    Object.defineProperty(GroupListComponent.prototype, "pageEvent", {
        get: function () {
            return this._pageEvent;
        },
        set: function (value) {
            this._pageEvent = value;
            this.page = value.pageIndex;
            this.addUrlPageParam(value.pageIndex + 1);
            this.reloadConversations();
        },
        enumerable: true,
        configurable: true
    });
    GroupListComponent.prototype.pageChange = function (e) {
        window.scroll(0, 0);
    };
    GroupListComponent.prototype.addUrlPageParam = function (value) {
        var queryParams = { page: value };
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
        });
    };
    Object.defineProperty(GroupListComponent.prototype, "allConversationsCount", {
        get: function () {
            return this._allConversationsCount;
        },
        enumerable: true,
        configurable: true
    });
    GroupListComponent.prototype.reloadConversations = function (loading) {
        var _this = this;
        if (loading === void 0) { loading = true; }
        this.loading = loading;
        this.conversationService.getConversations(this.perPage, this.page).then(function (result) {
            _this.loading = false;
            _this.noConversationsInfo = (result.conversations == null || result.conversations.length == 0);
            _this.conversations = result.conversations;
            _this.conversations.forEach(function (conversation) {
                conversation.messages.forEach(function (message) {
                    if (message.images.length > 0) {
                        if (_this.images[conversation.conversationId] == null) {
                            _this.images[conversation.conversationId] = {};
                        }
                        _this.images[conversation.conversationId][message.conversationMessageId] = _this.prepareImages(message);
                    }
                });
            });
            _this.refreshingLastList = false;
        }).catch(function (error) {
            _this.loading = false;
            _this.mainService.showError(error);
        });
    };
    //new
    GroupListComponent.prototype.prepareImages = function (message) {
        var images = message.images.map(function (img) {
            return {
                small: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                medium: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                big: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName
            };
        });
        return images;
    };
    GroupListComponent.prototype.setReadedMessages = function (conversation) {
        this.conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(function (c) { return c.conversationMessageId; }));
    };
    Object.defineProperty(GroupListComponent.prototype, "selectedConvCount", {
        get: function () {
            var _this = this;
            //this._selectedConvCount = document.getElementsByClassName("isSelected").length;
            this._selectedConvCount = 0;
            this.checboxListArray.forEach(function (e) {
                if (e['checked'] == true) {
                    _this._selectedConvCount++;
                }
            });
            return this._selectedConvCount;
        },
        enumerable: true,
        configurable: true
    });
    GroupListComponent.prototype.selectAllConversations = function (e) {
        if (e.checked) {
            this.checboxListArray.forEach(function (e) {
                e['checked'] = true;
            });
        }
        else {
            this.checboxListArray.forEach(function (e) {
                e['checked'] = false;
            });
        }
    };
    GroupListComponent.prototype.selectConversation = function (e, i) {
        var convClassList = this.convListArray[i].nativeElement.classList;
        if (e.checked) {
        }
        else {
        }
        convClassList.toggle('isSelected');
        if (this.selectedConvCount == this.convListArray.length) {
            this.selectAllCheckbox = true;
        }
        else {
            this.selectAllCheckbox = false;
        }
    };
    GroupListComponent.prototype.deleteSelectedConv = function () {
        var _this = this;
        this.mainService.showConfirm("Are you sure to delete " + this.selectedConvCount + " conversations ?", "300px").then(function (res) {
            if (res == confirmation_sheet_component_1.ConfirmationResult.Yes) {
                _this.loading = true;
                var tmpDeletedCount_1 = 0;
                _this.checboxListArray.forEach(function (e) {
                    if (e['checked']) {
                        _this.conversationService.deleteConversation(parseInt(e.id)).then(function (res) {
                            tmpDeletedCount_1++;
                            if (_this.selectedConvCount == tmpDeletedCount_1) {
                                _this.mainService.showInformation("Conversations deleted");
                                _this.reloadConversations();
                            }
                        }).catch(function (err) {
                            _this.mainService.showError(err);
                        });
                    }
                });
            }
        });
    };
    return GroupListComponent;
}());
exports.GroupListComponent = GroupListComponent;
